import React, { useState } from 'react';

const NotebookCard = ({ title, count, className, onClick, notebook }) => {
  const [isHovered, setIsHovered] = useState(false);

  const wrapTitle = (text, maxLength = 15) => {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    const pushChunks = (word) => {
      while (word.length > maxLength) {
        lines.push(word.slice(0, maxLength));
        word = word.slice(maxLength);
      }
      return word;
    };

    for (let word of words) {
      if (word.length > maxLength) {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = '';
        }
        word = pushChunks(word);
        if (word) currentLine = word;
      } else if ((currentLine + ' ' + word).trim().length <= maxLength) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    }
    if (currentLine) lines.push(currentLine);
    return lines.slice(0, 4);
  };

  const titleLines = wrapTitle(title);

  return (
    <div
      className={`${className} cursor-pointer relative`}
      onClick={() => onClick(notebook || { title, count, type: 'notebook' })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ perspective: '1200px', width: '155px', height: '204px' }}
    >
      {/* Left Dark Spine */}
      <div
        className="absolute left-0 top-0 h-full z-[5]"
        style={{
          width: '6px',
          backgroundColor: '#D2D8EE',
          borderTopLeftRadius: '2px',
          borderBottomLeftRadius: '2px',
        }}
      />

      {/* Flip Animation for Left Body */}
      <div
        className="absolute left-[6px] top-0 z-10 w-[146px] h-full transition-transform duration-700 ease-in-out"
        style={{
          transformStyle: 'preserve-3d',
          transform: isHovered ? 'rotateY(-35deg)' : 'rotateY(0deg)',
          transformOrigin: 'left center',
        }}
      >
        <svg
          width="146"
          height="204"
          viewBox="0 0 146 204"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full"
        >
          {/* Notebook background */}
          <rect width="146" height="204" fill="var(--q3-accent-light)" />

          {/* Title */}
          <text
            x="12"
            y="30"
            fontFamily="Inter"
            fontSize="16"
            fontWeight="700"
            fill="var(--q3-neutral-default)"
            style={{ letterSpacing: '-0.16px' }}
          >
            {titleLines.map((line, index) => (
              <tspan key={index} x="12" dy={index === 0 ? '0' : '1.2em'}>
                {line}
              </tspan>
            ))}
          </text>

          {/* Count */}
          <text
            x="12"
            y="170"
            fontFamily="Inter"
            fontSize="14"
            fontWeight="500"
            fill="var(--q3-neutral-default)"
            style={{ letterSpacing: '-0.14px' }}
          >
            {count}
          </text>

          <text
            x="12"
            y="190"
            fontFamily="Inter"
            fontSize="12"
            fontWeight="400"
            fill="var(--q3-neutral-default)"
            style={{ letterSpacing: '-0.12px' }}
          >
            Bookmarked Qs
          </text>
        </svg>
      </div>

      {/* Right Edge - Shifted slightly outward */}
      <svg
        width="155"
        height="204"
        viewBox="0 0 155 204"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute top-0 left-[4px] z-[1] pointer-events-none"
        style={{
          transform: 'translateX(3px)', // slight shift outward for detached look
        }}
      >
        <mask id="path-1-inside-1" fill="white">
          <path d="M146 8H155V196H146V8Z" />
        </mask>
        <path
          d="M155 8H159V4H155V8ZM155 196V200H159V196H155ZM146 8V12H155V8V4H146V8ZM155 8H151V196H155H159V8H155ZM155 196V192H146V196V200H155V196Z"
          fill="var(--q3-stroke-normal)"
          mask="url(#path-1-inside-1)"
        />
      </svg>
    </div>
  );
};

export default NotebookCard;
